import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Token bilgilerini LocalStorage'dan al
     const loginResponse = LocalStorageService.getDecodedLocalStorageObject();

    const appToken = loginResponse?.kisiTokenDto?.appToken || '';
    const language = loginResponse?.kisiTokenDto?.language || 'tr';

    // İsteği klonla ve başlıkları ekle
    const clonedRequest = req.clone({
      setHeaders: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'appToken': appToken,
        'language': language
      }
    });

    // Debugging için isteklerin loglanması
    // console.log('HTTP Request with Auth Headers:', clonedRequest);

    return next.handle(clonedRequest); // HTTP isteği işleme devam eder
  }
}
